let patchQueue = Promise.resolve();
let lastPatchId = 0;
let hasPatchError = false;

export function enqueueCharacteristicSequencePatch<Result>(
    patch: () => Promise<Result>,
    onQueueDrain: (hasError: boolean) => void
) {
    const patchId = ++lastPatchId;
    const patchResult = patchQueue.then(patch);

    patchQueue = patchResult.then(
        () => undefined,
        () => {
            hasPatchError = true;
        }
    );

    void patchQueue.then(() => {
        if (patchId === lastPatchId) {
            const hasError = hasPatchError;

            hasPatchError = false;
            onQueueDrain(hasError);
        }
    });

    return patchResult;
}
